document.addEventListener('DOMContentLoaded', function () {
    const values = ['products', 'projects'];

    values.forEach(value => {
        const menuItem = document.querySelector(`.mega-menu-${value}`);
        const megaMenuSection = document.getElementById(`mega-menu-${value}`);
        let hideTimer;

        // console.log(menuItem);
        // console.log(megaMenuSection);

        if (menuItem && megaMenuSection) {
            
            // Mouse event
            menuItem.addEventListener('mouseenter', showMenu);
            menuItem.addEventListener('mouseleave', hideMenu);
            megaMenuSection.addEventListener('mouseenter', clearHideTimer);
            megaMenuSection.addEventListener('mouseleave', hideMenu);

            // Touch event
            menuItem.addEventListener('touchstart', toggleMenu);
            megaMenuSection.addEventListener('touchstart', clearHideTimer);

            function clearHideTimer() {
                clearTimeout(hideTimer);
            }

            function showMenu() {
                clearHideTimer();
                megaMenuSection.classList.add('show');
            }

            function hideMenu() {
                hideTimer = setTimeout(function () {
                    megaMenuSection.classList.remove('show');
                }, 250);
            }

            function toggleMenu() {
                if (megaMenuSection.classList.contains('show')) {
                    megaMenuSection.classList.remove('show');
                } else {
                    megaMenuSection.classList.add('show');
                }
            }
        }
    });

    const menuItems = document.querySelectorAll(".menu-item-has-children > a");

    function isMobile() {
        return window.matchMedia("(max-width: 980px)").matches; 
    }

    if (isMobile()) {
    menuItems.forEach((link) => {
        link.addEventListener("click", function (event) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();

            const parentItem = this.parentElement;

            // Close other open sub-menus
            const openSubMenus = document.querySelectorAll(".menu-item-has-children.active");
            openSubMenus.forEach((menu) => {
                if (menu !== parentItem) {
                    menu.classList.remove("active");
                    const openSubMenu = menu.querySelector(".sub-menu");
                    if (openSubMenu) {
                        openSubMenu.style.maxHeight = null;
                    }
                }
            });

            // Toggle current sub-menu
            const subMenu = parentItem.querySelector(".sub-menu");
            if (subMenu) {
                if (parentItem.classList.contains("active")) {
                    subMenu.style.maxHeight = null;
                    parentItem.classList.remove("active");
                } else {
                    subMenu.style.maxHeight = subMenu.scrollHeight + "px";
                    parentItem.classList.add("active");
                }
            }
        });
    });
    }

});

jQuery(function($) {
    $(document).ready(function() {
        $("body ul.et_mobile_menu li.menu-item-has-children, body ul.et_mobile_menu  li.page_item_has_children").append('<a href="#" class="mobile-toggle"></a>');
        $('ul.et_mobile_menu li.menu-item-has-children .mobile-toggle, ul.et_mobile_menu li.page_item_has_children .mobile-toggle').click(function(event) {
            event.preventDefault();
            $(this).parent('li').toggleClass('dt-open');
            $(this).parent('li').find('ul.children').first().toggleClass('visible');
            $(this).parent('li').find('ul.sub-menu').first().toggleClass('visible');
        });
    });
}); 

jQuery(document).ready(function(){
    jQuery(".et_mobile_menu .menu-item-has-children a").each(function(){
        jQuery(this).click(function(event){
            event.preventDefault();
            jQuery(".et_mobile_menu").toggleClass("pa-block");
            jQuery(this).siblings("ul").toggleClass("pa-submenu");
        })
    })
})